import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-sans"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col p-4 pt-6 divide-y divide-brand-dark-gray"
}
const _hoisted_3 = { class: "flex text-white p-4 py-5" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.8998 20.25L12.1498 3.375C12.0045 3.12422 11.7537 3 11.5006 3C11.2475 3 10.9943 3.12422 10.8514 3.375L1.10138 20.25C0.813094 20.7516 1.17403 21.375 1.75059 21.375H21.2506C21.8272 21.375 22.1881 20.7516 21.8998 20.25ZM10.7506 9.9375C10.7506 9.83437 10.835 9.75 10.9381 9.75H12.0631C12.1662 9.75 12.2506 9.83437 12.2506 9.9375V14.25C12.2506 14.3531 12.1662 14.4375 12.0631 14.4375H10.9381C10.835 14.4375 10.7506 14.3531 10.7506 14.25V9.9375ZM11.5006 18.1875C11.2062 18.1815 10.9259 18.0603 10.7198 17.85C10.5137 17.6397 10.3983 17.357 10.3983 17.0625C10.3983 16.768 10.5137 16.4853 10.7198 16.275C10.9259 16.0647 11.2062 15.9435 11.5006 15.9375C11.795 15.9435 12.0753 16.0647 12.2814 16.275C12.4874 16.4853 12.6029 16.768 12.6029 17.0625C12.6029 17.357 12.4874 17.6397 12.2814 17.85C12.0753 18.0603 11.795 18.1815 11.5006 18.1875Z",
    fill: "white"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_7 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex text-white p-4 py-5" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<svg class=\"w-6 h-6 text-white fill-current\" width=\"75\" height=\"74\" viewBox=\"0 0 75 74\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M37.5006 0C17.2891 0 0.845703 16.4434 0.845703 36.6549C0.845703 56.8664 17.2891 73.3098 37.5006 73.3098C57.7121 73.3098 74.1555 56.8664 74.1555 36.6549C74.1555 16.4434 57.7121 0 37.5006 0Z\"></path><path d=\"M57.344 45.3167C58.4435 46.0038 58.7864 47.4604 57.9969 48.4889C55.9488 51.1572 53.3663 53.3809 50.4055 55.0124C46.7574 57.0225 42.6561 58.0668 38.4909 58.0461C34.3257 58.0254 30.235 56.9404 26.6071 54.8941C23.6626 53.2332 21.1024 50.984 19.0809 48.2954C18.3017 47.2591 18.659 45.806 19.7653 45.1298V45.1298C20.8716 44.4537 22.3061 44.8129 23.1088 45.8312C24.6966 47.8454 26.6667 49.5371 28.9137 50.8045C31.8446 52.4577 35.1494 53.3342 38.5142 53.3509C41.8791 53.3677 45.1924 52.524 48.1396 50.9001C50.3991 49.6551 52.3859 47.9831 53.9937 45.9847C54.8064 44.9745 56.2445 44.6295 57.344 45.3167V45.3167Z\" fill=\"#1A1B22\"></path><path d=\"M24.5105 40.1582C25.6758 40.2425 26.5724 41.2661 26.2606 42.392C26.0533 43.1407 25.7645 43.8666 25.3979 44.5563C24.6993 45.8709 23.7338 47.0251 22.5633 47.9449C21.3928 48.8648 20.043 49.53 18.6006 49.8981C17.8437 50.0912 17.0701 50.2003 16.2937 50.2247C15.1259 50.2615 14.3434 49.1483 14.5369 47.9961V47.9961C14.7304 46.8439 15.8401 46.1029 16.9933 45.9156C17.1817 45.8849 17.3689 45.846 17.5545 45.7986C18.4262 45.5762 19.2417 45.1742 19.949 44.6184C20.6563 44.0625 21.2397 43.3651 21.6619 42.5708C21.7518 42.4016 21.834 42.2289 21.9082 42.0531C22.3629 40.9768 23.3453 40.0738 24.5105 40.1582V40.1582Z\" fill=\"#1A1B22\"></path><path d=\"M32.9536 30.0211C33.9533 29.3009 34.1629 27.8739 33.2204 27.0804C32.4583 26.4388 31.6057 25.8977 30.6849 25.4747C29.0674 24.7316 27.287 24.3744 25.4949 24.4336C23.7028 24.4927 21.9521 24.9664 20.3917 25.8144C19.5056 26.2959 18.6958 26.89 17.9827 27.5781C17.0949 28.4348 17.4025 29.8458 18.45 30.4975V30.4975C19.4438 31.1157 20.7341 30.7992 21.6606 30.0839C21.9433 29.8657 22.2449 29.669 22.5627 29.4963C23.5056 28.9839 24.5635 28.6977 25.6463 28.6619C26.7292 28.6262 27.8051 28.842 28.7824 29.291C29.1166 29.4445 29.4358 29.6237 29.7373 29.8263C30.7047 30.4766 32.0077 30.7024 32.9536 30.0211V30.0211Z\" fill=\"#1A1B22\"></path><path d=\"M51.5546 32.8109C54.0696 32.8109 56.1406 30.849 56.1406 28.39C56.1406 25.9309 54.0696 23.9691 51.5546 23.9691C49.0396 23.9691 46.9686 25.9309 46.9686 28.39C46.9686 30.849 49.0396 32.8109 51.5546 32.8109Z\" fill=\"#1A1B22\" stroke=\"#1A1B22\" stroke-width=\"0.916372\"></path></svg>", 1)
const _hoisted_14 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_15 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "flex flex-col p-4 pt-6 divide-y divide-brand-dark-gray"
}
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "flex space-x-2" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1_216911)\"><path d=\"M2.81301 15.9669L1.54635 21.4336C1.50265 21.6334 1.50415 21.8405 1.55073 22.0397C1.59731 22.2389 1.6878 22.4251 1.81559 22.5849C1.94337 22.7446 2.10523 22.8738 2.28933 22.9629C2.47343 23.0521 2.67513 23.099 2.87968 23.1003C2.97499 23.1099 3.07103 23.1099 3.16635 23.1003L8.66635 21.8336L19.2263 11.3136L13.333 5.43359L2.81301 15.9669Z\" fill=\"white\"></path><path d=\"M22.5471 6.04697L18.6138 2.11364C18.3552 1.85635 18.0053 1.71191 17.6405 1.71191C17.2757 1.71191 16.9257 1.85635 16.6671 2.11364L14.4805 4.30031L20.3671 10.187L22.5538 8.00031C22.6818 7.87169 22.7831 7.71911 22.852 7.55128C22.921 7.38346 22.9561 7.20369 22.9555 7.02226C22.9549 6.84083 22.9185 6.6613 22.8484 6.49395C22.7784 6.3266 22.676 6.17471 22.5471 6.04697Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_1_216911\"><rect width=\"24\" height=\"24\" fill=\"white\" transform=\"translate(0 0.5)\"></rect></clipPath></defs></svg>", 1)
const _hoisted_23 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_24 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = { class: "flex space-x-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.1667 6.1H17.8333V4.1C17.8333 3.2175 17.0859 2.5 16.1667 2.5H7.83333C6.91406 2.5 6.16667 3.2175 6.16667 4.1V6.1H2.83333C2.3724 6.1 2 6.4575 2 6.9V7.7C2 7.81 2.09375 7.9 2.20833 7.9H3.78125L4.42448 20.975C4.46615 21.8275 5.20052 22.5 6.08854 22.5H17.9115C18.8021 22.5 19.5339 21.83 19.5755 20.975L20.2187 7.9H21.7917C21.9062 7.9 22 7.81 22 7.7V6.9C22 6.4575 21.6276 6.1 21.1667 6.1ZM15.9583 6.1H8.04167V4.3H15.9583V6.1Z",
    fill: "white"
  })
], -1)
const _hoisted_31 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_32 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "safe-area-bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.postOwner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reportComment && _ctx.reportComment(...args))),
                    class: "flex space-x-2"
                  }, [
                    _hoisted_5,
                    (!_ctx.reportBusy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Report comment"))
                      : _createCommentVNode("", true),
                    (_ctx.reportBusy)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.wink && _ctx.wink(...args))),
                    class: "flex space-x-2"
                  }, [
                    _hoisted_13,
                    (!_ctx.winkBusy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Wink at " + _toDisplayString(_ctx.comment.posted_by.name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.winkBusy)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.postOwner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editPost && _ctx.editPost(...args))),
                class: "flex text-white p-4 py-5"
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    (!_ctx.deleteBusy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Edit comment"))
                      : _createCommentVNode("", true),
                    (_ctx.deleteBusy)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_27))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args))),
                class: "flex text-white p-4 py-5"
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    (!_ctx.deleteBusy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Delete comment"))
                      : _createCommentVNode("", true),
                    (_ctx.deleteBusy)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_35))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_36
      ]))
    : _createCommentVNode("", true)
}